import { EditItem, IEditItem } from "../common/editItem";
import { RecordEducationScopeUnit } from "ui/Scripts/source/models/enums";

export interface IUserFurtherEducationEditItem extends IEditItem {
    furtherEducationId: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;
}

export class UserFurtherEducationEditItem extends EditItem implements IUserFurtherEducationEditItem {
    furtherEducationId: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    scopeUnitStr: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;

    constructor();
    constructor(obj: IUserFurtherEducationEditItem);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.scopeUnitStr = obj && obj.scopeUnitStr || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
    }
}

export class UserFurtherEducationEditItemSave extends EditItem {
    furtherEducationId: string;
    scope: number;
    scopeUnit: RecordEducationScopeUnit;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    comment: string;
    activeState: number;

    constructor();
    constructor(obj: IUserFurtherEducationEditItem);
    constructor(obj?: any) {
        super(obj);
        this.furtherEducationId = obj && obj.furtherEducationId || "";
        this.scope = obj && obj.scope || 0;
        this.scopeUnit = obj && obj.scopeUnit || RecordEducationScopeUnit.Hour;
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
    }
}